import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";
import { api, errMsg } from "@/lib/api";

const today = () => new Date().toLocaleDateString("sv-SE", { timeZone: "Europe/Rome" });

export const TollAdminDialog = ({ item, onClose, onSaved }) => {
  const [f, setF] = useState({ paid: !!item.paid, paid_date: item.paid_date || "", admin_note: item.admin_note || "", attention: !!item.attention });
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      await api.put(`/tolls/${item.id}/admin`, { ...f, paid_date: f.paid ? f.paid_date || null : null });
      toast.success("Gestione salvata");
      onSaved();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-lg" data-testid="toll-admin-dialog">
        <DialogHeader>
          <DialogTitle>Gestione mancato pedaggio · {item.plate}</DialogTitle>
          <DialogDescription>Se inserisci una nota o metti "Da attenzionare", la riga si colora per avvisare l'operatore.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <label className="flex items-center gap-3 rounded-lg border p-3">
            <Checkbox checked={f.paid} onCheckedChange={(c) => setF((p) => ({ ...p, paid: !!c, paid_date: c ? p.paid_date || today() : "" }))} data-testid="toll-paid-checkbox" />
            <span className="flex-1 font-medium">Pagato</span>
            {f.paid && <Input type="date" value={f.paid_date} onChange={(e) => setF((p) => ({ ...p, paid_date: e.target.value }))} className="w-44" data-testid="toll-paid-date" />}
          </label>
          <label className="flex items-center gap-3 rounded-lg border border-rose-200 bg-rose-50/50 p-3">
            <Checkbox checked={f.attention} onCheckedChange={(c) => setF((p) => ({ ...p, attention: !!c }))} data-testid="toll-attention-checkbox" />
            <span className="font-medium text-rose-700">Da attenzionare</span>
          </label>
          <div className="space-y-1.5"><Label>Nota per l'operatore</Label><Textarea rows={3} value={f.admin_note} onChange={(e) => setF((p) => ({ ...p, admin_note: e.target.value }))} data-testid="toll-admin-note" /></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Annulla</Button>
          <Button onClick={save} disabled={busy} data-testid="toll-admin-save">{busy ? "Salvataggio..." : "Salva"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
